// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3mYxL","legacyBtn":"MutateMid_legacyBtn__2KpGP"};